// extracted by mini-css-extract-plugin
export default {"layout":"leftColumn_layout__+YR6C","image":"leftColumn_image__gAxY0","content":"leftColumn_content__68Yi5"};